import { forwardRef } from "react";

import type { SxProps, Theme } from "@mui/material/styles";

// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { HoverBoxBase, type HoverBoxProps } from "@/components/HoverBoxBase";

const formRootSx: SxProps<Theme> = (theme) => {
  return {
    padding: theme.spacing(2),
    borderRadius: theme.radius(1),
    border: `1px solid ${theme.palette.border.neutral.quiet}`,
    backgroundColor: theme.palette.surface.neutral.white,
    cursor: "pointer",
    overflow: "hidden",
    transition: theme.transitions.create(["background-color"], {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeInOut,
    }),
    ":hover": {
      background: theme.palette.surface.neutral.supershy,
    },
  };
};

const formContentSx: SxProps<Theme> = (theme) => ({
  flex: 1,
  paddingRight: theme.spacing(1),
  ...theme.mixins.truncateOverflow,
  [theme.breakpoints.down("sm")]: {
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "clip",
  },
});

export const FormHoverBox = forwardRef<HTMLDivElement, HoverBoxProps>((props, ref) => (
  <HoverBoxBase {...props} ref={ref} rootSx={formRootSx} contentSx={formContentSx} />
));

FormHoverBox.displayName = "FormHoverBox";
